import { parsePhoneNumber, PhoneNumber } from 'react-phone-number-input';

type phoneNumberFormatOptions = 'national' | 'international';

const formatPhoneNumber = (phoneNumber: string, format: phoneNumberFormatOptions = 'international') => {
  try {
    const parsedPhoneNumber = getParsedPhoneNumber(phoneNumber);
    const formattedPhoneNumber = getFormattedPhoneNumber(parsedPhoneNumber, format);
    return formattedPhoneNumber;
  } catch (_exception) {
    return phoneNumber;
  }
};

const getFormattedPhoneNumber = (
  parsedPhoneNumber: PhoneNumber,
  format: phoneNumberFormatOptions = 'international'
): string => {
  if (format == 'international') {
    return parsedPhoneNumber.formatInternational();
  }
  return parsedPhoneNumber?.formatNational();
};

const getParsedPhoneNumber = (phoneNumber: string): PhoneNumber => {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

  if (
    parsedPhoneNumber == undefined ||
    parsedPhoneNumber?.countryCallingCode == undefined ||
    !parsedPhoneNumber.isValid()
  ) {
    throw new Error("The phone number can't be parsed correctly.");
  }

  return parsedPhoneNumber;
};

export const PhoneUtil = {
  formatPhoneNumber,
};
